import {
  Box,
  Button,
  Container,
  createStyles,
  Dialog,
  DialogActions,
  Divider,
  IconButton,
  makeStyles,
  Slide,
  Theme,
  Typography,
  withStyles
} from "@material-ui/core";
import React, {useCallback} from "react";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import {TransitionProps} from "@material-ui/core/transitions";
import {useDispatch, useSelector} from "react-redux";
import {deleteParticipantList, getParticipantList} from "../../../../store/actions/participant/list";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F0F0F0',
    paddingTop: "30px",
    fontFamily: 'roboto-regular',
    height: '100%',
    overflowX: 'hidden',
  },
  content: {
    minHeight: '100%',
    padding: theme.spacing(4),
    paddingBottom: 100,
    paddingTop: theme.spacing(6),
    '@media (min-width: 2000px)': {
      width: 1600
    },
  },
  dialogWrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  actionBtn: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  contentDialog: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  delBtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
  },
  cancelBtn: {
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  btn: {
    margin: 8
  },
  listName: {
    fontWeight: 'bold',
    fontFamily: 'roboto-regular',
  },
}));

const styles = (theme: Theme) =>
  createStyles({
    modalHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      color: theme.palette.grey[500],
      fontFamily: 'roboto-bold',
    },
    closeBtnIcon: {
      color: '#212D4080',
      width: 24,
      height: 24,
      fontFamily: 'roboto-bold'
    },
    modalTitle: {
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'left'
    }
  });

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.modalHeader} {...other}>
      <Typography variant="h5" className={classes.modalTitle}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon classes={{ root: classes.closeBtnIcon }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
}))(MuiDialogContent);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
  open: boolean,
  onClose: () => void,
  selectedList: any
}

const DeleteList = (props: IProps) => {
  const classes = useStyles();
  const { open, onClose, selectedList } = props;
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const onDeleteList = useCallback(() => {
    onClose();

    const request = {
      group_id: Number(selectedList.group_id)
    };
    dispatch(deleteParticipantList(apolloClient.client, request, (res: boolean) => {
      if (res) {
        dispatch(getParticipantList(apolloClient.client, false));
      }
    }));
  }, [selectedList]);

  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth={"sm"}
      classes={{
        paper: classes.dialogWrap
      }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title" onClose={() => onClose()}>
        Delete List
      </DialogTitle>

      <Divider />

      <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Container maxWidth="md">
          <Typography className={classes.contentDialog}>
            Are you sure you want to delete this list? It will not delete the participants, but just remove the list from your dashboard.
          </Typography>
          <Typography className={classes.listName}>{selectedList && (selectedList.group_name)}</Typography>
          <br/>
          <Typography className={classes.contentDialog}>This operation cannot be undone.</Typography>
        </Container>
      </DialogContent>

      <DialogActions>
        <Container maxWidth="md" className={classes.actionBtn}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Box mr={2}>
              <Button
                onClick={() => onClose()}
                variant="contained"
                className={classes.cancelBtn}
              >
                Cancel
              </Button>
            </Box>
            <Button
              onClick={onDeleteList}
              variant="contained"
              color="secondary"
              className={classes.delBtn}
            >
              {'Delete'}
            </Button>
          </Box>
        </Container>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteList;